import { useCallback } from "react";

import {
  formatDateForAPI,
  getFirstBusinessDayOfMonth,
  getNextBusinessDay,
} from "../utils/date-time-utils";

export const useUpdateURL = (startDate?: string) => {
  const updateURL = useCallback(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    // Get the first business day of next month
    const nextMonth = currentMonth === 11 ? 0 : currentMonth + 1;
    const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
    const firstBusinessDayNextMonth = getFirstBusinessDayOfMonth(
      nextYear,
      nextMonth,
    );

    let startDateFinal: Date;

    // If current date is before the first business day of next month, use that
    if (today < firstBusinessDayNextMonth) {
      startDateFinal = firstBusinessDayNextMonth;
    } else {
      // Otherwise, use today or next business day
      const dayOfWeek = today.getDay();
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        startDateFinal = getNextBusinessDay(today);
      } else {
        startDateFinal = today;
      }
    }

    const startDateString = formatDateForAPI(startDateFinal);
    const url = new URL(window.location.href);
    url.searchParams.set("startDate", startDateString);
    window.history.replaceState({}, "", url.toString());
  }, [startDate]);

  return { updateURL };
};
